export class RemainingDataEntryTime {
  constructor(
    public days: number = 0,
    public hours: number = 0,
    public minutes: number = 0) {
  }
}
